import axios from "axios";
import * as APITypes from "constants/API"
import StorageKeys from "constants/StorageKeys";
class Utils {
    prefillProductsList = async () => {
        let agentID = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)
        let isPosp =  localStorage.getItem(StorageKeys.IS_POSP)
        const response = await axios.get(`${APITypes.GET_PRODUCTS_LIST}?agent_id=${agentID}&is_posp=${isPosp}`)
        return response.data;
    }
}
export default new Utils();